import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft, Shield, Smartphone } from "lucide-react";
import { handleSend } from "../../../controllers/controller.all";
import SubmitButton from "../../../components/ui/SubmitButton";

export default function AdminCreate() {
    const user = useSelector((state) => state.userReducer?.user);
    const token = user?.access_token || "";
    const ecoleId = user?.ecole?._id || user?.ecole;
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [sendSms, setSendSms] = useState(true);
    const [formData, setFormData] = useState({
        nom: "",
        prenom: "",
        email: "",
        tel: "",
        adresse: "",
        password: "",
        genre: "",
        date_naissance: "",
        subrole: ""
    });

    const formatPart = (str) => {
        if (!str) return "";
        const part = str.trim().split(/\s+/)[0];
        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => {
            const nextData = { ...prev, [name]: value };
            if (name === "nom" || name === "prenom") {
                const n = name === "nom" ? value : prev.nom;
                const p = name === "prenom" ? value : prev.prenom;
                if (n || p) {
                    nextData.password = formatPart(n) + formatPart(p).toLowerCase() + "123&";
                } else {
                    nextData.password = "";
                }
            }
            return nextData;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            ...formData,
            role: "ADMIN",
            ecole: ecoleId
        };
        const res = await handleSend(e, "/user/signin", payload, setLoading, token);
        if (res && (res.state === "success" || res.status === "success")) {
            if (sendSms && formData.tel) {
                const messageText = `Bonjour, votre compte Administrateur KalanYoro a été créé. Identifiant: ${formData.tel}. Mot de passe: ${formData.password}. Veuillez supprimer ce message après l'avoir lu et gardez votre mot de passe en sécurité.`;
                const smsPayload = { to: formData.tel, message: messageText };
                await handleSend(null, "/sms/send", smsPayload, null, token);
            }
            navigate("/admins");
        }
    };

    return (
        <div className="flex flex-col gap-6 max-w-3xl mx-auto">
            <div className="flex items-center gap-4">
                <Link to="/admins" className="p-2 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition text-gray-500">
                    <ArrowLeft className="h-5 w-5" />
                </Link>
                <div>
                    <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Nouvel Administrateur</h1>
                    <p className="text-sm text-gray-500">Remplissez les informations ci-dessous pour ajouter un administrateur.</p>
                </div>
            </div>

            <form onSubmit={handleSubmit} className="bg-white shadow-sm border border-gray-200 rounded-xl overflow-hidden">
                <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="col-span-1 border-b md:border-b-0 md:col-span-2 pb-4 mb-2 border-gray-200">
                        <h2 className="text-lg font-medium text-gray-900">Informations Personnelles</h2>
                    </div>

                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Prénom *</label>
                        <input required type="text" name="prenom" value={formData.prenom} onChange={handleChange} className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" placeholder="Ex: Jean" />
                    </div>

                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Nom de famille *</label>
                        <input required type="text" name="nom" value={formData.nom} onChange={handleChange} className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" placeholder="Ex: Dupont" />
                    </div>

                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Email</label>
                        <input type="email" name="email" value={formData.email} onChange={handleChange} className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" placeholder="jean@example.com" />
                    </div>

                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Téléphone *</label>
                        <input required type="text" name="tel" value={formData.tel} onChange={handleChange} className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" placeholder="Ex: +221 77..." />
                    </div>

                    <div className="space-y-2 md:col-span-2">
                        <label className="text-sm font-medium text-gray-700">Adresse</label>
                        <input type="text" name="adresse" value={formData.adresse} onChange={handleChange} className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" placeholder="Ex: Dakar, Sénégal" />
                    </div>

                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Rôle spécifique</label>
                        <input type="text" name="subrole" value={formData.subrole} onChange={handleChange} className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" placeholder="Ex: Secrétaire, Directeur..." />
                    </div>

                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Genre</label>
                        <select 
                            name="genre"
                            value={formData.genre} 
                            onChange={handleChange} 
                            className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white"
                        >
                            <option value="">Non spécifié</option>
                            <option value="M">Masculin</option>
                            <option value="F">Féminin</option>
                        </select>
                    </div>

                    <div className="space-y-2">
                        <label className="text-sm font-medium text-gray-700">Date de naissance</label>
                        <input 
                            type="date" 
                            name="date_naissance"
                            value={formData.date_naissance} 
                            onChange={handleChange} 
                            className="w-full border border-gray-300 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" 
                        />
                    </div>

                    <div className="col-span-1 md:col-span-2 mt-4 pb-4 mb-2 border-b border-gray-200 flex items-center gap-2">
                        <Shield className="h-5 w-5 text-indigo-500" />
                        <h2 className="text-lg font-medium text-gray-900">Sécurité et Accès</h2>
                    </div>

                    <div className="space-y-2 md:col-span-1">
                        <label className="text-sm font-medium text-gray-700">Mot de passe provisoire *</label>
                        <input required type="text" name="password" value={formData.password} onChange={handleChange} minLength="8" className="w-full border border-gray-300 bg-gray-50 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" placeholder="Généré automatiquement" />
                        <p className="text-xs text-gray-500 mt-1">Généré automatiquement à partir du nom et prénom.</p>
                    </div>

                    <div className="space-y-2 md:col-span-1 flex flex-col justify-center pt-6">
                        <label className="flex items-start gap-3 p-3 border border-indigo-100 bg-indigo-50/50 rounded-lg cursor-pointer hover:bg-indigo-50 transition">
                            <div className="flex items-center h-5 mt-0.5">
                                <input
                                    type="checkbox"
                                    checked={sendSms}
                                    onChange={(e) => setSendSms(e.target.checked)}
                                    className="w-4 h-4 text-indigo-600 bg-white border-gray-300 rounded focus:ring-indigo-500"
                                />
                            </div>
                            <div className="flex flex-col">
                                <span className="text-sm font-medium text-indigo-900 flex items-center gap-1.5">
                                    <Smartphone className="h-4 w-4" /> Envoyer un SMS
                                </span>
                                <span className="text-xs text-indigo-700 mt-0.5">
                                    Transmet automatiquement les accès (téléphone et mot de passe) au nouvel administrateur.
                                </span>
                            </div>
                        </label>
                    </div>
                </div>

                <div className="bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
                    <Link to="/admins" className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition">
                        Annuler
                    </Link>
                    <SubmitButton 
                        type="submit" 
                        isSubmitting={loading}
                        loadingText="Enregistrement..."
                    >
                        Créer le profil Administrateur
                    </SubmitButton>
                </div>
            </form>
        </div>
    );
}
